


















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Pipeline } from '@/api/model/pipeline'
import { Status } from '@/api/model/status'
import { PipelinePhase } from '@/api/model/pipeline-phase'
import { InputSelectOption } from '@/helpers/options'
import { PipelineAPI, StatusAPI } from '@/api/backend-client'
import LoaderBalls from '@/components/LoaderBalls.vue'
import { ReferralStatus } from '@/api/types'

export class ImportStatusReasonsFormModel implements ImportStatusReasonsFormInterface {
    status: Status = null
    pipeline: Pipeline = null
    fromPhase: PipelinePhase = null
    toPhase: PipelinePhase = null
}

export interface ImportStatusReasonsFormInterface {
    status: Status
    pipeline: Pipeline
    fromPhase: PipelinePhase
    toPhase: PipelinePhase
}

@Component({
    components: {LoaderBalls},
})
export default class ImportStatusReasonsForm extends Vue {
    @Prop() readonly pipeline!: Pipeline
    @Prop() readonly status!: Status
    @Prop() readonly value!: ImportStatusReasonsFormInterface

    loading = true
    pipelines: Pipeline[] = []
    statuses: Status[] = []

    async mounted() {
        await this.loadPipelines()
        await this.loadStatuses()
        this.loading = false
    }

    async loadStatuses() {
        this.statuses = await StatusAPI.getAll({
            company: this.$currentCompany.id,
        })
    }

    async loadPipelines() {
        this.pipelines = (await PipelineAPI.getAll({
            company: this.$currentCompany.id,
        })).filter(pipeline => pipeline.active)
    }

    setPipelineValue(pipelineId) {
        this.value.pipeline = this.pipelines.find(pipeline => pipeline.id === pipelineId)
        this.value.fromPhase = null
        this.value.toPhase = null
    }

    get isOpenStatus(): boolean {
        return this.status.status === ReferralStatus.OPEN
    }

    get statusOptions(): InputSelectOption[] {
        if (this.isOpenStatus) {
            return [{
                label: this.$t('referral.phaseModelStatus.open').toString(),
                value: 'open',
            }]
        }

        return [{
            label: this.$t('referral.phaseModelStatus.closed').toString(),
            value: 'closed',
        }, {
            label: this.$t('referral.phaseModelStatus.successful').toString(),
            value: 'successful',
        }]
    }

    get pipelineOptions(): InputSelectOption[] {
        return this.pipelines.map(pipeline => {
            return {
                label: pipeline.name,
                value: pipeline.id,
            }
        })
    }
}
